import { useEffect } from 'react';

export function useOnScroll(onScroll?: () => void) {
	useEffect(() => {
		if (!onScroll) {
			return;
		}

		window.addEventListener('scroll', onScroll);

		return () => {
			window.removeEventListener('scroll', onScroll);
		};
	}, [onScroll]);
}
